// removed by extract-text-webpack-plugin
module.exports = {"bg":"_33H0p","base":"_1nr_a","sectionHeader":"RqhAN","title":"_2K9xP","content":"_39ibq","spinner":"_1n1gy","list":"_3ImKL","fieldset":"_3i6OJ","form":"_3SWMv","group":"_1tiYs","footer":"_2Wcb5"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Beneficiaries/BeneficiaryDisplayForm.scss
// module id = 211
// module chunks = 0